import { isNil } from 'lodash'
import { DIRECTION } from '~/enums'
import { time2Pixel } from '~/Util'

// Сalculation of the X coordinates of the current dragged asset (under the mouse pointer)
export const setDropX = ({
  historyX,
  draggableBlockStartTime,
  leftXOffset,
  currentDraggableAsset,
  draggableAssets,
  intersectionPlaceholder,
  insertBetween,
  scale,
  sourceOffset,
  isIntersected,
  isOverlapped,
  overNewLayerIndex,
  intersectionEqualSegment,
  diffBetweenCurrentDragItemNFirstDragItem,
  draggableBlockDuration,
  isExternalSource,
}) => {
  let { dropX, intersectedData } = historyX.current
  const deltaBetweenAssets = isExternalSource
    ? 0
    : currentDraggableAsset?.startTime - draggableAssets?.[0]?.startTime
  const isPlaceholder = insertBetween || intersectionPlaceholder

  if (draggableBlockStartTime <= 0
    && (!isOverlapped || (isPlaceholder && isNil(overNewLayerIndex)))) {
    dropX = time2Pixel(deltaBetweenAssets, scale)
  } else if (isPlaceholder && isNil(overNewLayerIndex)) {
    dropX = time2Pixel((isPlaceholder?.startTime), scale)
  } else if (intersectionEqualSegment && historyX.current.readyForDrop) {
    dropX = time2Pixel(intersectionEqualSegment?.startTime, scale)
  } else if (historyX.current.readyForDrop) {
    dropX = historyX.current.stopDragLeftX - leftXOffset
      + time2Pixel(diffBetweenCurrentDragItemNFirstDragItem, scale)
  } else if (isIntersected && isNil(overNewLayerIndex)) {
    if (historyX.current.moveDirection === DIRECTION.LEFT) {
      const delta = currentDraggableAsset.startTime
        - (intersectedData?.draggableAsset.startTime ?? 0)
      const stopTime = (intersectedData?.staticAsset.startTime ?? 0)
        + (intersectedData?.staticAsset.duration ?? 0)
      dropX = time2Pixel((stopTime + delta), scale)
    } else {
      let delta = currentDraggableAsset.startTime
        - (intersectedData?.draggableAsset.startTime ?? 0)
        - (intersectedData?.draggableAsset.duration ?? 0)
      const stopTime = (intersectedData?.staticAsset.startTime ?? 0)
      delta = isExternalSource ? draggableBlockDuration * -1 : delta
      dropX = time2Pixel(stopTime + delta, scale)
    }
  } else {
    dropX = sourceOffset.x - leftXOffset
  }
  return { dropX }
}
